class TextBlockConstants {
}
TextBlockConstants.TEXT_UPDATE_DELAY = 1000;
TextBlockConstants.SLASH = '/';
TextBlockConstants.EMPTY_TEXT_CODE = '\u200B';
export default TextBlockConstants;
